import { render } from "./score.vue?vue&type=template&id=d69b93fc&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=d69b93fc&scoped=true&lang=css"
import "./score.vue?vue&type=style&index=1&id=d69b93fc&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d69b93fc"]])

export default __exports__